export default {"src":"/_next/static/media/icon-tiktok.d9a15703.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};